var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTooltipSparks = function SvgTooltipSparks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 23,
    viewBox: "0 0 353 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4609 13.3519C14.1616 14.0993 15.3248 14.1677 16.1082 13.5074V13.5074C16.8483 12.8838 17.0108 11.8079 16.488 10.9934L11.1505 2.67777C10.2354 1.25219 8.28156 0.944054 6.9722 2.01883V2.01883C5.70717 3.05722 5.5837 4.94884 6.70301 6.14286L13.4609 13.3519Z",
    fill: "#FF5E6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.838 13.3519C340.137 14.0993 338.974 14.1677 338.191 13.5074V13.5074C337.451 12.8838 337.288 11.8079 337.811 10.9934L343.149 2.67777C344.064 1.25219 346.018 0.944054 347.327 2.01883V2.01883C348.592 3.05722 348.715 4.94884 347.596 6.14286L340.838 13.3519Z",
    fill: "#FF5E6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.969 17.8047C10.638 17.9947 11.3412 17.6419 11.5887 16.992V16.992C11.8345 16.3468 11.5502 15.6203 10.9317 15.3134L4.84528 12.2925C3.81358 11.7805 2.56462 12.2601 2.14082 13.3311V13.3311C1.71237 14.4138 2.31268 15.6297 3.43278 15.9479L9.969 17.8047Z",
    fill: "#FF5E6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.825 18.8047C342.156 18.9947 341.453 18.6419 341.206 17.992V17.992C340.96 17.3468 341.244 16.6203 341.863 16.3134L347.949 13.2925C348.981 12.7805 350.23 13.2601 350.654 14.3311V14.3311C351.082 15.4138 350.482 16.6297 349.362 16.9479L342.825 18.8047Z",
    fill: "#FF5E6D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTooltipSparks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tooltipSparks.17946e459f17933a17e3f5e3da50913e.svg";